import {
  Box,
  Checkbox,
  FormControl,
  FormLabel,
  styled,
  CircularProgress,
  FormControlLabel,
} from '@mui/material';
import { UserAccount } from '../../../data/models/user-account.model';
import { UserRole } from '../../../data/models/user-role.model';
import { useTranslation } from 'react-i18next';

const PREFIX = 'UserRolesForm';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));

export const isRoleChecked = (
  user: UserAccount | undefined | null,
  roleId: number | undefined,
): boolean => {
  const roles = [
    ...(user?.userCategoryInternals || []),
    ...(user?.userCategoryServiceAccounts || []),
    ...(user?.userCategoryTransportationProviders || []),
  ];
  const idx = roles.findIndex((r) => r.userRoleID === roleId);
  return idx >= 0;
};

interface UserRolesFormProps {
  readonly userRoles: UserRole[];
  readonly selectedRoles: number[];
  readonly loadingUserRoles: boolean;
  readonly readOnly: boolean;
  updateSelection: (id: number, checked: boolean) => void;
}

export default function UserRolesForm({
  selectedRoles,
  userRoles,
  loadingUserRoles,
  readOnly,
  updateSelection,
}: UserRolesFormProps) {
  const { t } = useTranslation('common');

  const handleSelection = (id: number, checked: boolean) => {
    updateSelection(id, checked);
  };

  return (
    <StyledBox className={classes.container}>
      <FormControl>
        <FormLabel color="info">{t('users.roles')}</FormLabel>
        {loadingUserRoles && <CircularProgress />}
        {!loadingUserRoles &&
          userRoles?.map((r) => {
            return (
              <FormControlLabel
                key={r.userRoleID}
                label={
                  r.description
                    ? `${r.userRoleName} - ${r.userRoleBC} (${r.description})`
                    : r.userRoleName
                }
                control={
                  <Checkbox
                    checked={selectedRoles.includes(r.userRoleID!)}
                    disabled={readOnly}
                    onChange={(_evt, val) =>
                      handleSelection(r.userRoleID!, val)
                    }
                  />
                }
              />
            );
          })}
      </FormControl>
    </StyledBox>
  );
}
